(function () {
  'use strict';

  function initGallery(root) {
    var thumbs = root.querySelectorAll('[data-cc-thumb]');
    var mainImageWrap = root.querySelector('[data-cc-main-image]');
    if (!mainImageWrap) return;
    var mainImg = mainImageWrap.querySelector('img');

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var url = thumb.getAttribute('data-image-url');
        if (url && mainImg) {
          mainImg.src = url;
        }
        thumbs.forEach(function (t) {
          t.classList.remove('is-active');
        });
        thumb.classList.add('is-active');
      });
    });
  }

  function initQuantity(root) {
    var input = root.querySelector('[data-cc-qty-input]');
    if (!input) return;
    var decrease = root.querySelector('[data-cc-qty-decrease]');
    var increase = root.querySelector('[data-cc-qty-increase]');

    if (decrease) {
      decrease.addEventListener('click', function () {
        var value = parseInt(input.value, 10) || 1;
        input.value = Math.max(1, value - 1);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    if (increase) {
      increase.addEventListener('click', function () {
        var value = parseInt(input.value, 10) || 1;
        input.value = value + 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
  }

  function initVariantPicker(root, sectionId) {
    var dataEl = document.querySelector('[data-cc-product-variants="' + sectionId + '"]');
    var optionButtons = root.querySelectorAll('[data-cc-option-value]');
    if (!dataEl || optionButtons.length === 0) return;

    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var variantIdInput = root.querySelector('[data-cc-variant-id]');
    var priceWrap = root.querySelector('[data-cc-price]');
    var stockWrap = root.querySelector('[data-cc-stock]');
    var mainImageWrap = root.querySelector('[data-cc-main-image]');
    var mainImg = mainImageWrap ? mainImageWrap.querySelector('img') : null;
    var addToCartButton = root.querySelector('.cc-product__add-to-cart');
    var lowStockThreshold = parseInt(root.getAttribute('data-low-stock-threshold'), 10) || 5;

    function getSelectedOptions() {
      var groups = {};
      optionButtons.forEach(function (btn) {
        if (btn.classList.contains('is-selected')) {
          groups[btn.getAttribute('data-option-position')] = btn.getAttribute('data-value');
        }
      });
      var positions = Object.keys(groups).sort(function (a, b) {
        return parseInt(a, 10) - parseInt(b, 10);
      });
      return positions.map(function (p) {
        return groups[p];
      });
    }

    function findMatchingVariant(selected) {
      for (var i = 0; i < variants.length; i++) {
        var opts = variants[i].options;
        var match = true;
        for (var j = 0; j < selected.length; j++) {
          if (opts[j] !== selected[j]) {
            match = false;
            break;
          }
        }
        if (match) return variants[i];
      }
      return null;
    }

    function updateUI(variant) {
      if (!variant) return;

      if (variantIdInput) {
        variantIdInput.value = variant.id;
        variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      if (priceWrap) {
        var priceHtml = '<span class="cc-product__price-value">' + variant.price + '</span>';
        if (variant.compare_at_price && variant.compare_at_price !== variant.price) {
          priceHtml += ' <span class="cc-product__price-compare">' + variant.compare_at_price + '</span>';
        }
        priceWrap.innerHTML = priceHtml;
      }

      if (stockWrap) {
        if (!variant.available) {
          stockWrap.innerHTML = '<span class="cc-product__stock-out">Currently sold out</span>';
        } else if (
          variant.inventory_management === 'shopify' &&
          variant.inventory_quantity > 0 &&
          variant.inventory_quantity <= lowStockThreshold
        ) {
          stockWrap.innerHTML =
            '<span class="cc-product__stock-low">Only ' + variant.inventory_quantity + ' left in stock</span>';
        } else {
          stockWrap.innerHTML = '<span class="cc-product__stock-ok">In stock, ready to ship</span>';
        }
      }

      if (mainImg && variant.featured_image) {
        mainImg.src = variant.featured_image;
      }

      if (addToCartButton) {
        if (variant.available) {
          addToCartButton.removeAttribute('disabled');
        } else {
          addToCartButton.setAttribute('disabled', 'disabled');
        }
      }
    }

    optionButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var position = btn.getAttribute('data-option-position');
        var group = root.querySelectorAll('[data-cc-option-value][data-option-position="' + position + '"]');
        group.forEach(function (el) {
          el.classList.remove('is-selected');
        });
        btn.classList.add('is-selected');

        var labelWrap = btn.closest('.cc-product__option');
        var labelTarget = labelWrap ? labelWrap.querySelector('[data-cc-option-selected]') : null;
        if (labelTarget) {
          labelTarget.textContent = btn.getAttribute('data-value');
        }

        var selected = getSelectedOptions();
        var variant = findMatchingVariant(selected);
        updateUI(variant);
      });
    });
  }

  function init() {
    document.querySelectorAll('.cc-product').forEach(function (root) {
      var sectionId = root.className.match(/cc-product--(\S+)/);
      initGallery(root);
      initQuantity(root);
      if (sectionId) {
        initVariantPicker(root, sectionId[1]);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
